export default {
  header: {
    projectName: 'Projektname',
    export: 'Exportieren',
    debug: 'Debuggen',
    success: 'Erfolg',
    failed: 'Fehlgeschlagen',
    generating: 'Video wird generiert...',
    updateNameFailed: 'Aktualisierung des Projektnamens fehlgeschlagen',
    menu: 'Menü',
    settings: 'Einstellungen',
    shortcuts: 'Tastaturkürzel',
    about: 'Über',
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    settingsComingSoon: 'Einstellungen bald verfügbar',
    shortcutsComingSoon: 'Tastaturkürzel bald verfügbar',
    aboutComingSoon: 'Über-Informationen bald verfügbar',
    language: 'Sprache',
    dimensions: 'Abmessungen',
    canvas: 'Leinwand',
    view: 'Ansicht',
    general: 'Allgemein'
  },
  menu: {
    media: 'Medien',
    text: 'Text'
  },
  loading: {
    core: 'Kern wird geladen...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Öffentliche Beta',
    betaDisclaimer: 'Beta-Version, Datenpersistenz nicht garantiert',
    newProject: 'Neues Projekt',
    backupFolder: 'Sicherungsordner',
    documentation: 'Dokumentation',
    recentProjects: 'Aktuelle Projekte',
    viewAll: 'Alle anzeigen ({count})',
    noProjects: 'Noch keine Projekte. Erstellen Sie Ihr erstes Projekt, um zu beginnen!',
    login: 'ANMELDEN',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Projekt erstellt',
    projectCreatedDesc: 'Neues Projekt erfolgreich erstellt',
    projectDeleted: 'Projekt gelöscht',
    projectDeletedDesc: 'Projekt erfolgreich gelöscht',
    deleteConfirmation: 'Sind Sie sicher, dass Sie dieses Projekt löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    migrationFailed: 'Migration fehlgeschlagen',
    migrationFailedDesc: 'Datenmigration von localStorage fehlgeschlagen',
    loadFailed: 'Laden fehlgeschlagen',
    loadFailedDesc: 'Laden der Projekte fehlgeschlagen',
    creationFailed: 'Erstellung fehlgeschlagen',
    creationFailedDesc: 'Erstellung des neuen Projekts fehlgeschlagen',
    deletionFailed: 'Löschen fehlgeschlagen',
    deletionFailedDesc: 'Löschen des Projekts fehlgeschlagen'
  },
  timeline: {
    autoSaveFailed: 'Automatisches Speichern fehlgeschlagen',
    autoSaveFailedDesc: 'Automatisches Speichern des Projekts fehlgeschlagen',
    loadFailed: 'Laden fehlgeschlagen',
    loadFailedDesc: 'Laden des Projekts fehlgeschlagen. Weiterleitung zur Startseite...',
    mainTrack: 'Hauptspur',
    undo: 'Rückgängig',
    redo: 'Wiederherstellen',
    split: 'Teilen',
    delete: 'Löschen'
  },
  attributes: {
    properties: 'Eigenschaften',
    position: 'Position',
    scale: 'Skalierung',
    animation: 'Animation',
    basic: 'Basis',
    mute: 'Stummschalten',
    text: 'Text',
    fontSize: 'Schriftgröße',
    content: 'Inhalt',
    fontFamily: 'Schriftart',
    direction: 'Textrichtung',
    color: 'Farbe',
    stroke: 'Umrandung',
    background: 'Hintergrund',
    video: 'Video',
    rotate: 'Drehen',
    backgroundColor: 'Hintergrundfarbe',
    opacity: 'Deckkraft',
    blend: 'Mischung',
    filter: 'Filter',
    effect: 'Effekt',
    transition: 'Übergang',
    speed: 'Geschwindigkeit',
    volume: 'Lautstärke'
  },
  router: {
    editor: 'Video-Editor',
    preview: 'Vorschau',
    storyboard: 'Storyboard - KI-Video-Agent'
  },
  placeholder: {
    text: 'Bitte Textinhalt eingeben',
    input: 'Bitte eingeben'
  },
  error: {
    parseAudio: 'Audio-Analyse fehlgeschlagen',
    parseImage: 'Bild-Analyse fehlgeschlagen',
    parseVideo: 'Video-Analyse fehlgeschlagen',
    noProject: 'Bitte erstellen oder öffnen Sie zuerst ein Projekt',
    invalidFileType: 'Ungültiger Dateityp'
  },
  media: {
    video: 'Video',
    image: 'Bild',
    audio: 'Audio',
    dropToUpload: 'Dateien hierher ziehen zum Hochladen'
  },
  common: {
    defaultText: 'Standardtext',
    delete: 'Löschen'
  }
};
